import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'floor_guid': 'String!',
	'timeslot_guid': '[String]!',
};

export default gql(`
	mutation floor_to_timeslot( ${ HelperGraphql.createFields( fields ) } ) {
	    floor_to_timeslot( ${ HelperGraphql.createVariables( fields ) } ) {
	        floor {
	            guid
	        }
	        
	        timeslot {
	            guid
	        }
	    }
	}
`);

